module.exports = __webpack_public_path__ + "img/hero-mobile.f3803669.webp";